import React from "react";
import { CTAButton } from "../CTAButton";
import { images } from "../../data/links";
const questions = ["What am I actually looking at?", "What matters here?", "How should I organize my thinking?", "What should I review before moving forward?"];
export function AuthorMessage() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-24" data-id="element-89" data-mp="2qur9mgbaftad">
      <div className="mx-auto grid max-w-5xl items-start gap-10 lg:grid-cols-[380px_1fr] lg:gap-14" data-id="element-90" data-mp="1t6qw1kgwf4mu">
        <figure className="mx-auto w-full max-w-sm lg:sticky lg:top-8" data-id="element-91" data-mp="1y5u31agfvkxg">
          <img src={images.author} alt="Dr. Michael Carter, plastic surgeon" className="aspect-[4/5] w-full rounded-3xl object-cover object-top" data-id="element-92" data-mp="1y62csth9ma4f" />
          <figcaption className="mt-3 text-center text-sm text-white/60" data-id="element-93" data-mp="285b5lj0e9ip7">Dr. Michael Carter · Plastic Surgeon</figcaption>
        </figure>

        <div data-id="element-94" data-mp="3jiwssymp1a83">
          <p className="text-sm font-bold uppercase tracking-wide text-goldlight" data-id="element-95" data-mp="3jinalx7w47cy">A message from Dr. Michael Carter</p>
          <h2 className="text-balance mt-3 font-serif text-3xl font-bold italic leading-tight sm:text-5xl" data-id="element-96" data-mp="2iikz51mcayg6">
            “I didn't create another mastopexy course.”
          </h2>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-white/80" data-id="element-97" data-mp="29i6fe6p0xres">
            <p data-id="element-98" data-mp="24k4udg81fi0o">
              I've spent years studying surgical education and observing how experienced surgeons approach complex cases.
              And one thing became increasingly clear to me:
            </p>
            <p className="font-serif text-xl font-semibold leading-snug text-white" data-id="element-99" data-mp="1uttfiymtfof0">
              Knowing individual techniques and knowing how to organize the entire case are not always the same thing.
            </p>
            <p data-id="element-100" data-mp="1luohdtf61x3d">
              You can watch another operation. Read another paper. Attend another conference. Study another technique.
              But eventually you have to sit down with a case and ask:
            </p>
          </div>

          <ol className="mt-5 space-y-2" data-id="element-101" data-mp="1bxjufrdhxxli">
            {questions.map((q, i) => <li key={q} className="flex items-start gap-3 text-[17px] font-semibold italic text-goldlight" data-id="element-102" data-mp="126ab4o4q5sep" data-mpi={i}>
                <span className="w-5 shrink-0 font-serif not-italic text-white/40" data-id="element-103" data-mp="174bqaxz157kw">{i + 1}.</span>“{q}”
              </li>)}
          </ol>

          <div className="mt-6 space-y-4 text-[17px] leading-relaxed text-white/80" data-id="element-104" data-mp="x9jspu5g6kq4">
            <p data-id="element-105" data-mp="1kxjlezmbkl7c">I wanted to create something I could hand to a surgeon and say:</p>
            <blockquote className="rounded-2xl bg-navy2 p-5 font-serif text-xl italic leading-snug text-white ring-1 ring-white/10" data-id="element-106" data-mp="1pwwgu8r9b0lj">
              “Open the case. Take 15 minutes. Work through the framework. Write down what you see. Then compare your
              reasoning with the educational review.”
            </blockquote>
            <p data-id="element-107" data-mp="23vw4bd3199g4">
              It isn't intended to replace surgical training, mentorship, clinical experience, institutional protocols
              or professional judgment. It is a structured educational system for studying mastopexy cases, organizing
              procedural knowledge and practicing a more disciplined approach to surgical review.
            </p>
            <p className="font-semibold text-white" data-id="element-108" data-mp="6y8b9dyd8e2f">
              If you're serious about improving the way you study mastopexy, I built this system for you.
            </p>
            <p className="font-serif text-2xl italic text-goldlight" data-id="element-109" data-mp="21hu0natrcff">— Dr. Michael Carter</p>
          </div>

          <div className="mt-8" data-id="element-110" data-mp="3ah1jdb8dkap7">
            <CTAButton label="I want access to Mastopexy Blueprint™" tone="dark" data-id="element-111" data-mp="35gx3nnfajk01" />
          </div>
        </div>
      </div>
    </section>;
}